import { Badge, Button, Radio } from 'antd';
import { NotificationCases } from 'enums/COAlertEnums';
import { BadgeColors } from 'enums/COBadgeEnums';
import React from 'react';
import COAlert from 'shared/components/COAlert';
import COAvatar from 'shared/components/COAvatar';
import COBadge from 'shared/components/COBadge';
import COButton from 'shared/components/COButton';
import UserProfile from 'assets/images/user_2.jpeg';
import { StarFilled, ArrowRightOutlined } from '@ant-design/icons';
import { BadgePlacements } from 'enums/COPopoverEnums';
import CONotification from 'shared/components/CONotification';
import COPopover from 'shared/components/COPopover';
import { Formik } from 'formik';
import SwitchComponent from 'shared/components/SwitchComponent';

const UIAppComponents = () => {
  const url =
    'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg';

  const [switchState, setSwitchState] = React.useState<boolean>(false);

  const RadioOptions = [
    { label: 'Apple', value: 'apple' },
    { label: 'Orange', value: 'orange' },
    { label: 'Pears', value: 'pears' },
    { label: 'Grapes', value: 'grapes', disabled: true },
  ];

  const handleSwitchChange = (switchState: boolean) =>
    setSwitchState(!switchState);

  return (
    <>
      <Formik initialValues={{}} onSubmit={values => {}}>
        <div className="mt-5">
          <h2>Radio</h2>
          <div className="mt-2 flex-inline">
            <Radio.Group
              name="radiogroup"
              options={RadioOptions}
              defaultValue={1}
            />
            <SwitchComponent
              name="switch"
              onChange={() => handleSwitchChange(switchState)}
            />
            {switchState ? <p>Switched</p> : null}
            <SwitchComponent name="switchDisabled" disabled />
          </div>
        </div>
      </Formik>

      <div className="mt-5">
        <h2>Avatars</h2>
        <div className="mt-2 flex-inline" style={{ width: '40%', gap: '20px' }}>
          <COAvatar>AA</COAvatar>
          <COAvatar icon={UserProfile} />
          <COAvatar icon={url} />
        </div>
      </div>
      <div className="mt-5">
        <h2>Badges</h2>
        <div className="mt-2 flex-inline" style={{ gap: '20px' }}>
          <Badge className="red">Location</Badge>
          <COBadge color={BadgeColors.BLUE}>Location</COBadge>
          <COBadge color={BadgeColors.PURPLE}>Birthday</COBadge>
          <COBadge color={BadgeColors.GREEN}>Click per minute</COBadge>
          <COBadge color={BadgeColors.RED}>Curabir test</COBadge>
          <COBadge color={BadgeColors.YELLOW}>Efficur odi nullam</COBadge>
          <COBadge color={BadgeColors.DARKGREEN}>Orci enim</COBadge>
          <COBadge color={BadgeColors.GREY}>Fringilla vel bibendum</COBadge>
          <COBadge color={BadgeColors.ORANGE}>Laoreet nisl</COBadge>
        </div>
      </div>
      <div className="mt-5">
        <h2>Notifications</h2>
        <div className="flex-inline" style={{ gap: '20px' }}>
          <COAlert
            type={NotificationCases.SUCCESS}
            descriptionText="Neutral info displayer here">
            <COButton>hello</COButton>
          </COAlert>
          <COAlert
            type={NotificationCases.SUCCESS}
            large
            descriptionText="This is the content for the the the.This is the content for the notification.This is the content for the notification.This is the content for the notification.">
            <COButton secondary>Big Notification</COButton>
          </COAlert>
          <COAlert
            type={NotificationCases.INFO}
            descriptionText="Neutral info displayer here">
            <COButton secondary>Information</COButton>
          </COAlert>
          <COAlert
            type={NotificationCases.SUCCESS}
            descriptionText="Neutral info displayer here">
            <COButton text>Success</COButton>
          </COAlert>
          <COAlert
            type={NotificationCases.WARNING}
            descriptionText="Neutral info displayer here">
            <COButton>Warning</COButton>
          </COAlert>
          <COAlert
            type={NotificationCases.ERROR}
            descriptionText="Neutral info displayer here">
            <COButton secondary>Error</COButton>
          </COAlert>
          <COAlert
            type={NotificationCases.FAILED}
            descriptionText="Neutral info displayer here">
            <COButton>Failed</COButton>
          </COAlert>
        </div>
      </div>
      <div className="mt-5">
        <h2>Popover</h2>
        <div
          className="mt-2 flex-inline"
          style={{ gap: '20px', display: 'flex', alignItems: 'center' }}>
          <COPopover placement={BadgePlacements.BOTTOM} text="text">
            <COBadge color={BadgeColors.BLUE}>color</COBadge>
          </COPopover>
          <COPopover placement={BadgePlacements.TOP} text="text">
            <Badge>Click </Badge>
          </COPopover>

          <COPopover placement={BadgePlacements.RIGHT} text="text">
            <Button type="default" icon={<StarFilled />}>
              Click
            </Button>
          </COPopover>
          <COPopover placement={BadgePlacements.LEFT} text="text">
            <COBadge>
              Click <ArrowRightOutlined />
            </COBadge>
          </COPopover>
          <COPopover actionable>
            <COButton>Click</COButton>
          </COPopover>
        </div>
      </div>
      <div className="mt-2 mb-10 ">
        <h2>Notification</h2>
        <div className="mt-5 flex-inline mb-5" style={{ width: '50%' }}>
          <CONotification count={4} />
          <CONotification transparent count={7} />
        </div>
      </div>
    </>
  );
};

export default UIAppComponents;
